import "./skills-page.css";

import Marquee from "react-fast-marquee";

function SkillsPage() {
  const technologies = [
    {
      name: "React",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013151/react_wwsjsl.svg",
    },
    {
      name: "Angular",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013147/angular_l3byl1.svg",
    },
    {
      name: "PHP",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013150/php_drqnjd.svg",
    },
    {
      name: "MongoDB",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013150/mongodb_nwp80k.svg",
    },
    {
      name: "SQL",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013152/mysql_npqwi8.svg",
    },
    {
      name: "Node/JS",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013149/nodejs_c0pjf9.svg",
    },
    {
      name: "Express/js",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013146/express_mkmdcp.svg",
    },
    {
      name: "Laravel",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013149/laravel_tusovz.svg",
    },
    {
      name: "HTML",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013152/html_ej1hzf.svg",
    },
    {
      name: "SCSS/ CSS",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013148/file-type-scss2_lk7hzl.svg",
    },
    {
      name: "Docker",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013147/docker_ovpnfr.svg",
    },
    {
      name: "Typescript",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013151/typescript_wonaz0.svg",
    },
    {
      name: "Javascript",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013150/javascript-js_krd5ai.svg",
    },
    {
      name: "JAVA",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013146/java_werz1z.svg",
    },
    {
      name: "Python",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013147/python_h93rp3.svg",
    },
    {
      name: "C#",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013148/c-sharp_j3jp3p.svg",
    },
    {
      name: ".NET",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013152/dot-net_d65k3v.svg",
    },
    {
      name: "GIT",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013148/git_okvx2b.svg",
    },
    {
      name: "MS Azure",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013149/microsoft-azure_rpy24v.svg",
    },
    {
      name: "Google Console",
      img: "https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013146/google-cloud_mf68xd.svg",
    },
  ];
  return (
    <div className="skill-main">
      <div className="skill-container">
        <div className="global-title" data-aos="fade-up">
          Knowledge Areas
        </div>
        <div className="global-subtitle" data-aos="fade-up">
          Technologies and Tools I Am Proficient In
        </div>

        <div className="grid-container">
          <Marquee
            pauseOnHover={true}
            speed={100}
            gradient={false}
            gradientWidth={30}
          >
            {technologies.map((tech) => (
              <div className="grid-item" data-aos="fade-left" key={tech.name}>
                <img className="grid-image" src={tech.img} alt={tech.name} />
                {tech.name}
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </div>
  );
}

export default SkillsPage;
